(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-story-intro"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__ironcladRevealInit) return;
    window.__ironcladRevealInit = true;

    var supportsIO = 'IntersectionObserver' in window;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal() {
      var els = document.querySelectorAll('.ironclad-reveal');
      if (!supportsIO || reduced) {
        els.forEach(function(el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function(el) { io.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveal);
    } else {
      reveal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-benefits"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function scan(root) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = (root || document).querySelectorAll('.ic-home-reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window) || reduced) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
      if (!window.__icHomeIO) {
        window.__icHomeIO = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');window.__icHomeIO.unobserve(entry.target);}});}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ window.__icHomeIO.observe(el); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){scan(document);}); } else { scan(document); }
    //if (!window.__icHomeSafety) { window.__icHomeSafety = true; setTimeout(function(){ document.querySelectorAll('.ic-home-reveal:not(.is-visible)').forEach(function(el){ el.classList.add('is-visible'); }); }, 1500); }
    document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-comparison"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function scan(root) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = (root || document).querySelectorAll('.ic-home-reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window) || reduced) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
      if (!window.__icHomeIO) {
        window.__icHomeIO = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');window.__icHomeIO.unobserve(entry.target);}});}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ window.__icHomeIO.observe(el); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){scan(document);}); } else { scan(document); }
    //if (!window.__icHomeSafety) { window.__icHomeSafety = true; setTimeout(function(){ document.querySelectorAll('.ic-home-reveal:not(.is-visible)').forEach(function(el){ el.classList.add('is-visible'); }); }, 1500); }
    document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-credibility-strip"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function scan(root) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = (root || document).querySelectorAll('.ic-home-reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window) || reduced) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
      if (!window.__icHomeIO) {
        window.__icHomeIO = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');window.__icHomeIO.unobserve(entry.target);}});}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ window.__icHomeIO.observe(el); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){scan(document);}); } else { scan(document); }
    //if (!window.__icHomeSafety) { window.__icHomeSafety = true; setTimeout(function(){ document.querySelectorAll('.ic-home-reveal:not(.is-visible)').forEach(function(el){ el.classList.add('is-visible'); }); }, 1500); }
    document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-expected-timeline"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function scan(root) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = (root || document).querySelectorAll('.ic-home-reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window) || reduced) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
      if (!window.__icHomeIO) {
        window.__icHomeIO = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');window.__icHomeIO.unobserve(entry.target);}});}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ window.__icHomeIO.observe(el); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){scan(document);}); } else { scan(document); }
    //if (!window.__icHomeSafety) { window.__icHomeSafety = true; setTimeout(function(){ document.querySelectorAll('.ic-home-reveal:not(.is-visible)').forEach(function(el){ el.classList.add('is-visible'); }); }, 1500); }
    document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function scan(root) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = (root || document).querySelectorAll('.ic-home-reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window) || reduced) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
      if (!window.__icHomeIO) {
        window.__icHomeIO = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');window.__icHomeIO.unobserve(entry.target);}});}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ window.__icHomeIO.observe(el); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){scan(document);}); } else { scan(document); }
    //if (!window.__icHomeSafety) { window.__icHomeSafety = true; setTimeout(function(){ document.querySelectorAll('.ic-home-reveal:not(.is-visible)').forEach(function(el){ el.classList.add('is-visible'); }); }, 1500); }
    document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-founder-quote"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function scan(root) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = (root || document).querySelectorAll('.ic-home-reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window) || reduced) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
      if (!window.__icHomeIO) {
        window.__icHomeIO = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');window.__icHomeIO.unobserve(entry.target);}});}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ window.__icHomeIO.observe(el); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){scan(document);}); } else { scan(document); }
    //if (!window.__icHomeSafety) { window.__icHomeSafety = true; setTimeout(function(){ document.querySelectorAll('.ic-home-reveal:not(.is-visible)').forEach(function(el){ el.classList.add('is-visible'); }); }, 1500); }
    document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-problem-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function scan(root) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = (root || document).querySelectorAll('.ic-home-reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window) || reduced) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
      if (!window.__icHomeIO) {
        window.__icHomeIO = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');window.__icHomeIO.unobserve(entry.target);}});}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ window.__icHomeIO.observe(el); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){scan(document);}); } else { scan(document); }
    //if (!window.__icHomeSafety) { window.__icHomeSafety = true; setTimeout(function(){ document.querySelectorAll('.ic-home-reveal:not(.is-visible)').forEach(function(el){ el.classList.add('is-visible'); }); }, 1500); }
    document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-value-stack"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function scan(root) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = (root || document).querySelectorAll('.ic-home-reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window) || reduced) { els.forEach(function(el){el.classList.add('is-visible');}); return; }
      if (!window.__icHomeIO) {
        window.__icHomeIO = new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');window.__icHomeIO.unobserve(entry.target);}});}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ window.__icHomeIO.observe(el); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){scan(document);}); } else { scan(document); }
    document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
    
        document.addEventListener('click', function(e) {
      var link = e.target.closest('.ic-tiers__cta');
      if (!link) return;
      var selectors = link.getAttribute('data-scroll-target');
      if (!selectors) return;
      var target = null;
      selectors.split(',').some(function(sel) {
        target = document.querySelector(sel.trim());
        return !!target;
      });
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
